import { gql } from '@apollo/client';

export const GET_PROPOSALS_TABLE_DATA = gql`
  query ProposalsForDeskingTable($voId: ID) {
    proposals(voId: $voId) {
      id
      amountRequested
      creditProductIds
      riskTier
      vendorOpportunityId
      accountId
      vendorSalespersonId
      firstName
      lastName
      email
      businessName
      status
      createdDateTime
      salesPersonName
      fullName
      paymentId
      saleType
      creditSubmissionDynamicsId
      lenderPaymentOptions {
        lenderId
        lenderType
        payment
        paymentId
        proposalId
        residual
        residualMultiplier
        term
        useMaxApprovedAmount
      }
    }
  }
`;
